import { Injectable } from "@angular/core";
import { GridViewKeyEventHandlerService } from "../../../../shared/services/grid-view-key-event-handler.service";
import { PickManagementDataEditorService } from "./pick-management-editor.service";

@Injectable()
export class PickManagementKeyEventHandlerService extends GridViewKeyEventHandlerService {

  constructor(public tableEditor: PickManagementDataEditorService) {
    super(tableEditor);
  }
  /* Function that listens to Enter/Tab keypress on input fields in edit mode
    and calls respective functions in case of EA fields*/
  public editKeyPressListner(event: any, row: any, columnMeta: any) {
    if (!(event.keyCode === 13 || event.keyCode === 9 || event.type === 'focusout')) {
      // ignore if not ENTER13 OR Tab9.
      return true;
    }
    // In backend metadata it is named as 'columnMeta.propertyName', in front end local object it is named as 'columnMeta.prop'
    let propertyName: string = columnMeta.prop;
    if (!propertyName) {
      propertyName = columnMeta.propertyName;
    }
    if (this.editing && event.keyCode === 13 && columnMeta.displayType === 'E') {
      const currentCell = this.gridOptions.api.getFocusedCell();
      const finalRowIndex = this.gridOptions.api.paginationGetRowCount() - 1;
      if (currentCell.rowIndex === finalRowIndex) {
        return;
      }
      this.gridOptions.api.stopEditing();
      this.gridOptions.api.clearFocusedCell();
      const colId = currentCell.column.colId;
      this.gridOptions.api.startEditingCell({
        rowIndex: currentCell.rowIndex + 1,
        colKey: colId
      });
      this.gridOptions.api.setFocusedCell(currentCell.rowIndex + 1, colId);
    }
    if (row.cells[propertyName].cVal === row.cells[propertyName].cValPrev) {
      if (event.keyCode === 9 && row.cells[propertyName].isValueInvalid) {
        this.clickFocusedCellId = '';
        row.focusedCellId = propertyName;
        return false;
      }
      return true;
    }
    const invocationTime = new Date();
    if ((invocationTime.getTime() - this.lastEditKeyPressListnerInvocationTime) < 300) {
      this.lastEditKeyPressListnerInvocationTime = invocationTime.getTime();
      return true;
    }
    this.clickFocusedCellId = '';
    // LFWM-3557- adding validation for orderLineNo entered.
    if (columnMeta.displayType === 'EA' && propertyName === 'orderLineNo') {
      this.tableEditor.validateOrderLineNo(row, propertyName, this.gridOptions);
      return false;
    }
    switch (columnMeta.displayType) {
      case 'EA':
        this.tableEditor.autoPopulate(row, propertyName);
        return false;
      case 'EL':
        this.tableEditor.autoPopulateLookupProperty(row, propertyName);
        return false;
      case 'L':
        this.tableEditor.autoPopulateLookupProperty(row, propertyName);
        return false;
      default:
        return true;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/pick-management/services/pick-management-key-event-handler.service.ts